const PH_TIME_ZONE = "Asia/Manila";

const phDateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: PH_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const pad2 = (value) => String(value).padStart(2, "0");

export const dateOnlyToDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const [, year, month, day] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDateInPhilippines = (value) => {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const parts = phDateFormatter.formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});

  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const todayInPhilippines = () => formatDateInPhilippines(new Date());

export const toStartOfPhilippineDay = (value) => dateOnlyToDate(formatDateInPhilippines(value));

export const addMonthsToDateOnly = (dateString, months) => {
  const date = dateOnlyToDate(dateString);
  if (!date) return "";
  date.setMonth(date.getMonth() + months);
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};
